module.exports = __webpack_public_path__ + "media/images/past_order_history/ic_Order-ba7e2f95665bb6a4e0f420af4a67c8cc.png";